"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function LivePreview() {
  const router = useRouter();

  useEffect(() => {
    const handleMessage = (event) => {
      const { data } = event;

      if (!data || !data.type) return;

      // Only process Strapi-related messages
      if (
        data.type !== "strapiUpdate" &&
        data.type !== "strapiScript" &&
        data.type !== "strapiPreview"
      ) {
        return;
      }

      console.log("[LivePreview] Received message:", data.type, "from origin:", event.origin);

      if (data.type === "strapiUpdate") {
        console.log("[LivePreview] Strapi content updated, refreshing page...");
        router.refresh();
      } else if (data.type === "strapiScript") {
        console.log("[LivePreview] Injecting Strapi preview script");
        const script = window.document.createElement("script");
        script.textContent = data.payload?.script;
        window.document.head.appendChild(script);
      }
    };

    window.addEventListener("message", handleMessage);

    // Let Strapi know the frontend iframe is ready
    if (window.parent !== window) {
      console.log("[LivePreview] Sending previewReady to Strapi parent");
      window.parent.postMessage({ type: "previewReady" }, "*");
    }

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [router]);

  return null;
}
